import "./RecentCard.css";

const RecentCard = ({ search }) => {
  const handleClick = (text) => {
    search(text);
  };

  return (
    <div className="RecentCard">
      <div className="Header">Recent Searched Topics</div>
      <div className="Content">
        <div
          className="Pil"
          onClick={() =>
            handleClick(
              "What has been reported about wildfire smoke and exacerbation of asthma and COPD?"
            )
          }
        >
          What has been reported about wildfire smoke and exacerbation of asthma
          and COPD?
        </div>
        <div
          className="Pil"
          onClick={() =>
            handleClick(
              "What is the evidence behind the most recent hypertension guideline changes?"
            )
          }
        >
          What is the evidence behind the most recent hypertension guideline
          changes?
        </div>
        <div
          className="Pil"
          onClick={() =>
            handleClick(
              "What are the changing demographics of cancers in women?"
            )
          }
        >
          What are the changing demographics of cancers in women?
        </div>
        <div
          className="Pil"
          onClick={() =>
            handleClick(
              "What are the risks and benefits of fluoridation of drinking water?"
            )
          }
        >
          What are the risks and benefits of fluoridation of drinking water?
        </div>
        <div
          className="Pil"
          onClick={() =>
            handleClick(
              "What is the association of COVID-19 vaccination with cardiovascular disease?"
            )
          }
        >
          What is the association of COVID-19 vaccination with cardiovascular
          disease?
        </div>
      </div>
    </div>
  );
};

export default RecentCard;
